import { Controller } from "@hotwired/stimulus"

// Warns when the selected month already has an invoice; submitting anyway
// lands on that existing invoice instead of creating a duplicate.
export default class extends Controller {
  static targets = ["month", "year", "alert"]
  static values = { invoiced: Array }

  connect() {
    this.update()
  }

  update() {
    const selected = `${this.yearTarget.value}-${this.monthTarget.value}`
    this.alertTarget.hidden = !this.invoicedValue.includes(selected)
  }
}
